<template>
  <div class="markdown-editor" style="margin-top: 28px; margin-bottom: 20px; position: relative;">
    <v-label v-model="is_label_active" :focused="focused" :absolute="true" :left="(is_label_active ? 0 : 10)">{{label}}</v-label>
    <vue-simplemde
      :class="{'dark' : $dark()}"
      v-model="val"
      ref="markdownEditor"
      :configs="configs"
    />
  </div>
</template>

<script>
export default {
  props: ['value', 'label'],
  data: () => ({
    focused: false
  }),
  computed: {
    is_label_active() {
      return this.focused || !_.isEmpty(this.value);
    },
    simplemde () {
      return this.$refs.markdownEditor.simplemde;
    },
    configs () {
      return {
        hideIcons: ['side-by-side', 'fullscreen'],
        spellChecker: false,
        status: false
      }
    },
    val: {
      get() {
        return this.value || "";
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted() {
    this.simplemde.codemirror.on('focus', (instance, changeObj) => {
      this.focused = true;
    });
    this.simplemde.codemirror.on('blur', (instance, changeObj) => {
      this.focused = false;
    });
  }
}
</script>
<style>
  .markdown-editor .v-label {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    top: 60px;
    z-index: 1000;
  }
  .markdown-editor .v-label.v-label--active {
    -webkit-transform: translateY(-78px) scale(.75);
    transform: translateY(-78px) scale(.75);
  }

  .markdown-editor .dark {
    color: lightgrey;
    background-color: #424242;
    border-radius: 5px 5px 0 0;
  }

  .markdown-editor .dark .fa {
    color: white !important;
  } 


  .markdown-editor .dark .fa:hover {
    color: black !important;
  } 

  .markdown-editor .dark .CodeMirror {
    color: black;
    background-color: #424242;
    color: white;
  }
</style>
